import {
  isCookieEnabled,
  isSessionStorageAvailable,
  isLocalStorageAvailable,
} from './utils'

type iToStore = (key: string, value: string) => void
type iGetFromStore = (key: string) => string | null
type iDeleteFromStore = (key: string) => void
export interface iStorageApi {
  toStore: iToStore
  getFromStore: iGetFromStore
  deleteFromStore: iDeleteFromStore
}
const sessionStorageApi = (): iStorageApi => {
  const toStore: iToStore = (key: string, value: string) => {
    sessionStorage.setItem(key, value)
  }

  const getFromStore: iGetFromStore = (key: string) => {
    return sessionStorage.getItem(key)
  }

  const deleteFromStore: iDeleteFromStore = (key: string) => {
    sessionStorage.removeItem(key)
  }

  return {
    toStore,
    getFromStore,
    deleteFromStore,
  }
}

const localStorageApi = (): iStorageApi => {
  const toStore: iToStore = (key: string, value: string) => {
    localStorage.setItem(key, value)
  }

  const getFromStore: iGetFromStore = (key: string) => {
    return localStorage.getItem(key)
  }

  const deleteFromStore: iDeleteFromStore = (key: string): void => {
    localStorage.removeItem(key)
  }

  return {
    toStore,
    getFromStore,
    deleteFromStore,
  }
}

const cookieStorageApi = (): iStorageApi => {
  const toStore: iToStore = (key: any, value: any) => {
    document.cookie = `${String(key)}=${String(value)};max-age=${
      60 * 60 * 24 * 365
    }`
  }

  const getFromStore: iGetFromStore = (key: any) => {
    const match = document.cookie.match(
      new RegExp(`(^| )${String(key)}=([^;]+)`),
    )
    if (match !== null) return match[2]
    return null
  }

  const deleteFromStore: iDeleteFromStore = (key: any) => {
    document.cookie = `${String(key)}=${String(
      getFromStore(key),
    )};max-age=${0}`
  }

  return {
    toStore,
    getFromStore,
    deleteFromStore,
  }
}

const getStore = (): iStorageApi | null => {
  if (isLocalStorageAvailable()) {
    return localStorageApi()
  } else if (isSessionStorageAvailable()) {
    return sessionStorageApi()
  } else if (isCookieEnabled()) {
    return cookieStorageApi()
  }
  return null
}

export {
  sessionStorageApi,
  localStorageApi,
  cookieStorageApi,
  getStore,
}
